import React, { useState } from "react";
import {
    BUTTON_STYLES,
    COLORS,
    MESSAGES,
    SPACING,
    TYPOGRAPHY,
} from "../constants/contentManagerAccessConstants";

/**
 * Props for LoginForm component
 * @typedef {Object} LoginFormProps
 * @property {() => Promise<void>} onLogin - Callback function to handle login
 * @property {string | null} error - Error message to display
 */
interface LoginFormProps {
    onLogin: () => Promise<void>;
    error: string | null;
}

/**
 * Component to display login
 * @param onLogin
 * @param error
 * @constructor
 */
export const LoginForm: React.FC<LoginFormProps> = ({ onLogin, error }) => {
    const [isHovered, setIsHovered] = useState(false);

    const buttonStyle = {
        width: "100%",
        padding: SPACING.BUTTON_PADDING,
        background: isHovered
            ? `linear-gradient(135deg, ${COLORS.PRIMARY_HOVER_START}, ${COLORS.PRIMARY_HOVER_END})`
            : `linear-gradient(135deg, ${COLORS.PRIMARY_GRADIENT_START}, ${COLORS.PRIMARY_GRADIENT_END})`,
        color: "white",
        border: "none",
        borderRadius: BUTTON_STYLES.BORDER_RADIUS,
        fontSize: TYPOGRAPHY.FONT_SIZE_BUTTON,
        cursor: "pointer",
        transition: "background 0.3s, transform 0.2s, box-shadow 0.3s",
        fontWeight: TYPOGRAPHY.FONT_WEIGHT_BUTTON,
        boxShadow: isHovered
            ? `0 ${BUTTON_STYLES.SHADOW_SPREAD_HOVER} ${BUTTON_STYLES.SHADOW_BLUR_HOVER} ${COLORS.PRIMARY_SHADOW_HOVER}`
            : `0 ${BUTTON_STYLES.SHADOW_SPREAD} ${BUTTON_STYLES.SHADOW_BLUR} ${COLORS.PRIMARY_SHADOW}`,
        marginTop: SPACING.MARGIN_TOP_BUTTON,
        transform: isHovered ? BUTTON_STYLES.TRANSFORM_HOVER : BUTTON_STYLES.TRANSFORM_DEFAULT,
    };

    const errorStyle = {
        marginTop: SPACING.MARGIN_TOP_ERROR,
        padding: `${SPACING.ERROR_PADDING_VERTICAL} ${SPACING.ERROR_PADDING_HORIZONTAL}`,
        backgroundColor: COLORS.ERROR_BG,
        border: `1px solid ${COLORS.ERROR_BORDER}`,
        borderRadius: BUTTON_STYLES.BORDER_RADIUS,
        color: COLORS.ERROR_TEXT,
        fontSize: TYPOGRAPHY.FONT_SIZE_ERROR,
        textAlign: "center" as const,
    };

    return (
        <div className="content-manager-access-container">
            <h2>{MESSAGES.SIGN_IN_TITLE}</h2>
            <p>{MESSAGES.SIGN_IN_DESCRIPTION}</p>

            <button
                type="button"
                onClick={() => void onLogin()}
                style={buttonStyle}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {MESSAGES.SIGN_IN_BUTTON}
            </button>

            {error && <div style={errorStyle}>{error}</div>}
        </div>
    );
};
